import CropOriginalIcon from '@mui/icons-material/CropOriginal';
import LoopIcon from '@mui/icons-material/Loop';
import { Button, Grid } from '@mui/material';
import { ResourceSelectorWidget } from 'src/components/widget/resourceSelectorWidget/ResourceSelectorWidget';
import { useGetAllAssets } from 'src/hooks';
import { lang } from 'src/utils';
import { getThumbnailSrc } from 'src/utils/gcf-helper';

import { CustomImageSelectionButtonProps } from './CustomImageSelectionButton.interface';

export const CustomImageSelectionButton = (
  props: CustomImageSelectionButtonProps,
) => {
  const { data: assets = [] } = useGetAllAssets();
  const matchedAsset = assets.find((a) => a.assetName === props.assetName);
  const thumbnailSrc =
    matchedAsset?.thumbnailUrl ?? getThumbnailSrc(props.assetName);

  return (
    <Grid container spacing={2}>
      {props.showButtonOnly ? (
        <Grid item xs={12}>
          <Button
            variant="outlined"
            component="label"
            onClick={props.handleClick}
            startIcon={<CropOriginalIcon />}>
            {lang.uploadImage}
          </Button>
        </Grid>
      ) : (
        <>
          <Grid item xs={12}>
            <ResourceSelectorWidget
              value={thumbnailSrc}
              onChange={() => {}}
              disabled
            />
          </Grid>

          <Grid item xs={12} container>
            <Grid item xs={4}>
              <Button
                component="label"
                variant="outlined"
                onClick={props.handleClick}
                startIcon={<LoopIcon />}>
                {lang.replace}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                variant="text"
                color="error"
                component="label"
                onClick={props.handleRemoveImage}>
                {lang.remove}
              </Button>
            </Grid>
          </Grid>
        </>
      )}
    </Grid>
  );
};
